import styled from "styled-components";
import { Link } from "react-router-dom";

import * as Types from "Types";

const Wrap = styled(Link)<Types.Default>`
   font-size: 31px;
   font-weight: 700;
   transition-duration: 0.3s;
   transition-property: color;
   transition-timing-function: ease-in-out;
   &:hover {
      color: #7f21f7;
   }
   ${({ css }) => css}
`;

export default function NowLogo(props: Types.Default) {
   return (
      <Wrap css={props.css} to={"/nows"}>
         NOW
      </Wrap>
   );
}
